import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['number_seven_seg'] = function (block: Blockly.Block): [string, number] {
        const v = block.getFieldValue('NUM') ?? '0';
        return expr(String(v));
    };
}
